import { useEffect, useRef, useState } from 'react';

type Timer = { max: number; interval?: number; direction?: 'asc' | 'desc' };

export function useTimer({ max, interval = 1000, direction = 'desc' }: Timer) {
  const isDesc = direction === 'desc';
  const [time, setTime] = useState(isDesc ? max : 0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    setTime(isDesc ? max : 0);
  };

  const clearTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  };

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTime(prevTime => {
        if (isDesc && prevTime > 0) {
          return prevTime - 1;
        } else if (!isDesc && prevTime < max) {
          return prevTime + 1;
        }
        return prevTime;
      });
    }, interval);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [interval, isDesc, max]);

  return {
    time,
    resetTimer,
    clearTimer,
  };
}
